import styled from 'styled-components'

export const ModalBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 14.5px;
  font-weight: 400;
  width: 100%;
`
export const RowContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border: 1px solid ${({ theme }) => theme.colors.backgroundLite};
  border-radius: 10px;

  & div {
    flex: 1;
  }
`
export const GridRowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  padding: 10px 0;
  gap: 20px;
`
export const Label = styled.div`
  font-weight: 700;
  ${({ error, theme }) => error && `color: ${theme.colors.red}`}
`
